import React, { useState, useMemo } from "react";
import { FaUserPlus, FaEdit, FaCheck, FaBan, FaUsers } from "react-icons/fa";
import ModalAddRepresentative from "./AddRepresentative";
import SchoolEdit from "./SchoolEdit";
import "bootstrap/dist/css/bootstrap.min.css";
import { usePut } from "../../customHooks/usePut";
import { useNavigate, useLocation } from "react-router-dom";

function SchoolTable({
  schools: initialSchools,
  totalPages,
  onPageChange,
  representatives,
  onAddUser,
}) {
  const [showModal, setShowModal] = useState(false);
  const [selectedSchoolId, setSelectedSchoolId] = useState(null); // Solo almacena el ID de la escuela
  const [showEditModal, setShowEditModal] = useState(false);
  const schools = initialSchools;
  const { executePut } = usePut();
 const navigate = useNavigate();
  const handleOpenModal = (schoolId) => {
    console.log("Abriendo modal para la escuela ID:", schoolId); // Verifica el ID de la escuela
    setSelectedSchoolId(schoolId); // Almacena solo el ID
    setShowModal(true);
  };

   const handleOpenMemebers = (schoolselected) => {
    console.log("Abriendo miembros para la escuela ID:", schoolselected); // Verifica el ID de la escuela
    navigate("/members", {
        state: { schoolselected },
      });
  };

  const handleOpenEditModal = (schoolId) => {
    setSelectedSchoolId(schoolId);
    setShowEditModal(true);
  };

  const handleToggleStatus = async (school) => {
    try {
      const updatedSchool = { ...school, status: !school.status };
      const response = await executePut(
        `https://ectech-software.com.ar/api/academy/schools/${school.id}`,
        updatedSchool
      );
      if (!response) throw new Error("No se pudo actualizar el estado de la escuela.");
  
      onAddUser(); // 👈 hace que el padre llame a refetch
    } catch (error) {
      console.error("Error al actualizar el estado de la escuela:", error);
      alert(`Error al cambiar el estado de la escuela: ${error.message}`);
    }
  };
  

  const schoolRows = useMemo(() => {
    return schools.map((school) => (
      <SchoolRow
        key={school.id}
        school={school}
        onEdit={() => handleOpenEditModal(school.id)}
        onToggleStatus={() => handleToggleStatus(school)}
        onAssignRepresentative={() => handleOpenModal(school.id)} // Pasa solo el ID de la escuela
        onMembersEdit={() => handleOpenMemebers(school.id)}
      />
    ));
  }, [schools]);

  const currentPage = schools.page >= 0 ? schools.page + 1 : 0;

  return (
    <div className="container mt-4 pb-5">
      <div className="table-responsive" style={{ maxHeight: "400px", overflowY: "auto" }}>
        <table className="table table-striped table-hover table-bordered text-center">
          <thead className="table-primary">
            <tr>
              <th>Nombre</th>
              <th>Dirección</th>
              <th>Ciudad</th>
              <th>Teléfono</th>
              <th>Correo Electrónico</th>
              <th>Representante</th>
              <th>Estado</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {schoolRows.length > 0 ? (
              schoolRows
            ) : (
              <tr>
                <td colSpan="8" className="text-center">
                  No hay escuelas disponibles
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div className="d-flex justify-content-between">
        <button
          onClick={() => onPageChange("prev")}
          className="btn btn-secondary"
          disabled={schools.page === 0}
        >
          Anterior
        </button>

        {currentPage > 0 && totalPages > 0 && (
          <span>{`Página ${currentPage} de ${totalPages}`}</span>
        )}

        <button
          onClick={() => onPageChange("next")}
          className="btn btn-secondary"
          disabled={schools.page + 1 === totalPages}
        >
          Siguiente
        </button>
      </div>

      {showModal && (
        <ModalAddRepresentative
          schoolId={selectedSchoolId} // Pasa solo el ID de la escuela
          onClose={() => setShowModal(false)}
          onAddUser={onAddUser}
        />
      )}

      {showEditModal && (
        <SchoolEdit
          schoolId={selectedSchoolId} // Pasa el ID de la escuela para la edición
          onClose={() => setShowEditModal(false)}
        />
      )}
    </div>
  );
}

const SchoolRow = React.memo(({ school, onEdit, onToggleStatus, onAssignRepresentative, onMembersEdit }) => {
  const schoolStatus = school.status ? "Activo" : "Inactivo";
  const statusClass = school.status ? "text-success fw-bold" : "text-danger fw-bold";

  return (
    <tr>
      <td>{school.name}</td>
      <td>{school.address}</td>
      <td>{school.city?.name || "Sin ciudad"}</td>
      <td>{school.phone}</td>
      <td>{school.mail}</td>
      <td>{school.user ? `${school.user.name} ${school.user.lastname}` : "Sin representante"}</td>
      <td className={statusClass}>{schoolStatus}</td>
      <td className="text-center">
        <div className="d-flex justify-content-evenly align-items-center gap-3">
          <button
            onClick={onAssignRepresentative}
            className="btn btn-success"
            aria-label="Asignar representante"
          >
            <FaUserPlus />
          </button>
          <button
            onClick={onToggleStatus} // ✅
            className={`btn ${school.status ? "btn-danger" : "btn-success"}`}
            aria-label={school.status ? "Desactivar escuela" : "Activar escuela"}
          >
            {school.status ? <FaBan /> : <FaCheck />}
          </button>
          <button
            onClick={onEdit}
            className="btn btn-warning"
            aria-label="Editar escuela"
          >
            <FaEdit />
          </button>
          <button
            onClick={onMembersEdit}
            className="btn btn-secondary"
            aria-label="Miembros"
          >
            <FaUsers />
          </button>
        </div>
      </td>
    </tr>
  );
});

export default SchoolTable;
